/**
 * apiClient: Centralized request wrapper ensuring Authorization headers
 * are only attached when a valid token exists, enforcing strict Content-Type checking
 * to intercept HTML fallback responses before JSON parsing, and handling 401 flows safely.
 */
const API_BASE = "/.netlify/functions";

export async function apiRequest(endpoint, options = {}) {
    const token = localStorage.getItem("llap_auth_token") || localStorage.getItem("llap_access_token");

    const headers = {
        "Content-Type": "application/json",
        ...(options.headers || {})
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const cleanEndpoint = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint;
    const response = await fetch(`${API_BASE}/${cleanEndpoint}`, {
        ...options,
        headers
    });

    if (response.status === 401) {
        // Do not force-wipe storage immediately on background polls, 
        // but throw a clean error indicating unauthorized state.
        const error = new Error("Unauthorized");
        error.status = 401;
        throw error;
    }

    // Strict Content-Type checking to intercept HTML responses (e.g., SPA index.html fallback)
    const contentType = response.headers.get("content-type") || "";
    if (!contentType.includes("application/json")) {
        const text = await response.text();
        const error = new Error(`Expected JSON but received ${contentType || 'unknown content-type'} (${response.status}). Response preview: ${text.substring(0, 200)}`);
        error.status = response.status;
        error.isHtmlFallback = true;
        throw error;
    }

    return response;
}